import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import PatientPartnersTable from './PatientPartnerTable';

// Partners are linked only through the partner flows, which carry the patient's contact; this tab
// lists them and keeps the identity value editable (POM-6492).
const PatientPartnersTab = () => {
  const { mpi } = useParams();

  return (
    <Grid container direction='column' spacing={2} sx={{ mt: 2 }}>
      <Grid item>
        <Typography variant='h6' component='h2'>
          Partners
        </Typography>
      </Grid>

      <Grid item>
        <PatientPartnersTable mpi={mpi} />
      </Grid>
    </Grid>
  );
};

export default PatientPartnersTab;
